<template>
  <div id="picking_list_main">

    <div id="menu">

      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <div v-for="(option, index) in sendSelectOptions" :key="index" class="radio">
          <input type="radio" class="btn-check" name="btnradio" :id="'btnradio1' + option.code" autocomplete="off" :value="option.value" v-model="filterIndex" @change="changeSendSelect()">
          <label class="btn btn-sm btn-outline-secondary" :for="'btnradio1' + option.code">{{option.label}}</label>
          <br>
          <label>{{sendTotal[option.value]}}</label>
        </div>
      </div>

      <div id="sku_sort" v-show="showSortTag">
        <label class="btn btn-sm btn-outline-secondary" @click="changeSortSelect()" >{{sortName}}</label>
      </div>

    </div>

    <div id="grid-table-contents">
      <div v-if="isList" class="grid-table-scroll">
        <table class="table table-striped table-sm table-hover sticky_table">
          <thead>
            <tr class="table-primary">
              <th class="col-header-number">No.</th>
              <th class="col-header-shelf-number">棚番号</th>
              <th class="col-header-send">配送方法</th>
              <th class="col-header-item" @click="clickedNameTitle()">商品名</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowItem, rowIndex) in items"
              v-bind:key="rowIndex"
              v-bind:id = "'list' + rowItem.json.index"
              @click="itemInfo(rowItem.json.id)"
              v-bind:class="checkedRowColor(rowItem.json.fileTop, rowItem.json.checked, rowItem.json.skiped)">
              <td>{{rowItem.json.number}}</td>
              <td class="col-shelf-number">{{rowItem.json.shelf_number}}</td>
              <td class="col-send">{{sendShow(rowItem.json.send)}}</td>
              <td class="col-item">{{itemShow(rowItem.json.name)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <span v-if="apiComplete">今日のデータをインポートしてください</span>
        <span v-else class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent, onMounted, computed, toRef } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import { CameraPosition } from '@/const/const'

export default defineComponent({
  props: {
    sendIndex: {
      default: 0
    },
    skuSort: {
      default: false
    },
    position: {
      default: CameraPosition.TOP
    }
  },
  setup (props) {
    const router = useRouter()
    const route = useRoute()
    const items = ref([])
    const apiComplete = ref(false)
    // const propsSendIndex = toRef(props, 'sendIndex')
    // const propsSkuSort = toRef(props, 'skuSort')

    const propsSendIndex = route.query.sendIndex == undefined ? 0 : Number(route.query.sendIndex)
    const propsSkuSort = route.query.skuSort == undefined ? false : route.query.skuSort
    const propPosition = route.query.position == undefined ? CameraPosition.TOP : Number(route.query.position)

    const shortName = ref(true)
    const filterIndex = ref(propsSendIndex)
    const skuSortValue = ref(propsSkuSort)
    // const position = toRef(props, 'position')
    const position = ref(propPosition)

    // 配送方法フィルター
    const sendSelectOptions = ref([
      { code: 0, label: 'すべて', value: 0 },
      { code: 1, label: '指定分', value: 1 },
      { code: 4, label: '同梱分', value: 4 },
      { code: 2, label: '2000円未満', value: 2 },
      { code: 3, label: '2000円以上', value: 3 }
    ])

    const sendTotal = ref([0, 0, 0, 0])

    const setListItems = () => {
      apiComplete.value = false
      // console.log(props)
      // console.log(sendIndex.value)
      // console.log(filterIndex.value)
      axios.post('/api/barcode/list', { sendIndex: Number(filterIndex.value), skuSort: Number(skuSortValue.value) })
        .then((res) => {
          console.log(res)
          items.value = res.data.items
          apiComplete.value = true
          sendTotal.value = res.data.total.map(x => x.notCheckedCount)
        })
    }

    onMounted(() => {
      console.log('2026/04/17')
      console.log(position.value)
      console.log(typeof (position.value))
      position.value = Number(position.value)
      console.log('postion list')
      console.log(position.value)

      if (typeof (skuSortValue.value) === 'string') {
        skuSortValue.value = (skuSortValue.value === 'true')
      }

      filterIndex.value = Number(filterIndex.value)

      console.log('list skuSort')
      console.log(typeof (filterIndex.value))
      // console.log('skuSort')
      // console.log(typeof (skuSortValue.value))
      // console.log(skuSortValue.value)
      // filterIndex.value = filterIndex.value
      setListItems()
    })

    // Listデータの有無
    const isList = computed(() => {
      return items.value.length > 0
    })

    // 行の色
    /*
    const checkedRowColor = computed(() => {
        return (checked, skiped) => {
        const rtn = {
          'item-skiped': false,
          'item-checked': false
        }
        console.log('color')
        console.log(checked)
        console.log(skiped)
        if (checked) {
          if (skiped) {
            rtn['item-skiped'] = true
          } else {
            rtn['item-checked'] = true
          }
        }
        return rtn
      }
    })
      */

  const checkedRowColor = (tag, checked, skiped) => {
        const rtn = {
          top: false,
          'item-skiped': false,
          'item-checked': false
        }
        if (checked) {
          if (skiped) {
            rtn['item-skiped'] = true
          } else {
            rtn['item-checked'] = true
          }
        }
        if (tag) {
          rtn.top = true
        }
        return rtn
      }
  


    // sort名
    const sortName = computed(() => {
      return skuSortValue.value ? '棚番号 順' : 'No. 順'
    })

    // sort機能表示
    const showSortTag = computed(() => {
      return (filterIndex.value === 1 || filterIndex.value === 4)
    })

    // 商品名の文字数
    const itemShow = (buf) => {
      let rtn = buf
      if (shortName.value && buf.length > 7) {
        rtn = rtn.substr(0, 7) + '…'
      }
      return rtn
    }

    // 配送方法の表記
    const sendShow = (send) => {
      let rtn = ''
      switch (send) {
        case 0:
          rtn = 'ゆうメール'
          break
        case 1:
          rtn = 'ネコポス'
          break
        case 2:
          rtn = '指定分'
          break
        case 3:
          rtn = 'ゆうメール★'
          break
        case 4:
          rtn = 'ネコポス★'
          break
        case 5:
          rtn = 'ゆうパック★'
          break
      }
      return rtn
    }

    const itemInfo = (id) => {
      console.log('sku')
      console.log(id)
      console.log(skuSortValue.value)
      router.push({ name: 'barcodeChecker', query: { id: id, sendIndex: Number(filterIndex.value), skuSort: skuSortValue.value, position: position.value } })
    }

    const clickedNameTitle = () => {
      shortName.value = !shortName.value
    }

    const changeSendSelect = () => {
      skuSortValue.value = false
      setListItems()
    }

    const changeSortSelect = () => {
      skuSortValue.value = !skuSortValue.value
      setListItems()
    }

    /*
    const topBorder = (tag) => {
      let style = {}
      if (tag) {
        style = { top: true }
      }
      return style
    }
      */




    return {
      filterIndex,
      items,
      sendTotal,
      apiComplete,
      sendSelectOptions,
      isList,
      checkedRowColor,
      itemShow,
      sendShow,
      itemInfo,
      changeSendSelect,
      changeSortSelect,
      clickedNameTitle,
      // topBorder,
      sortName,
      showSortTag
    }
  }
})
</script>
<style lang="scss" scoped>
#picking_list_main {
  position: relative;
  width: 100%;
  height: 100%;

  #menu {
    position: relative;
    top : 0px;
    height: 20%;
    width: 100%;

    div.radio {
      padding: 1%;
    }
  }

  #grid-table-contents {
    position: absolute;
    bottom : 10%;
    height: 70%;
    width: 100%;
  }

}

tr.item-skiped {
  --bs-table-bg: #FFC000;
  background-color: #FFC000;
}

tr.item-skiped td {
  --bs-table-bg: #FFC000;
  background-color: #FFC000;
}

tr.item-checked {
  --bs-table-bg: #C6EFCE;
  background-color: #C6EFCE;
}


tr.item-checked > td {
  --bs-table-bg: #C6EFCE;
  background-color: #C6EFCE;
}

.sticky_table {
  width: 100%;
}
.sticky_table thead th {
  /* 縦スクロール時に固定する */
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  /* tbody内のセルより手前に表示する */
  z-index: 1;
}
div.grid-table-scroll {
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  font-size: medium;
}

tr.top {
    border-top:2px solid black;
}

td.checked {
  font-weight: bold;
  color: #00B050;
}
td.col-item {
  text-align: left;
  white-space: nowrap;
}
td.col-send {
  white-space: nowrap;
}
td.col-shelf-number {
  white-space: nowrap;
}
th.col-header-number {
}
th.col-header-shelf-number {
}
th.col-header-send {
}
th.col-header-item {
}
</style>
